import * as React from 'react';
import { AuthenticateWithRedirectCallback } from '@clerk/nextjs';
import { NextPage } from 'next';

const SSOCallbackPage: NextPage = () => {
  return <AuthenticateWithRedirectCallback redirectUrl='/callback' />;
};

export default SSOCallbackPage;